import React from 'react';
import './Gadziak.css';
import { PageTitle } from '../../components';
import {gadziakData} from '../../constants';

const Gadziak = () => {
    const data = gadziakData[0];

    if (!data) return null; 
    return (
        <div className="gadziak__wrapper">
            <PageTitle title={'Gądziak w Ogrodzie'} page={'Gądziak w ogrodzie'} />

            <section className='gadziak__section'>
                <div className='gadziak__container'>

                    {/* Lewa kolumna - Zdjęcie */}
                    <div className='gadziak__image-wrapper'>
                        <img 
                            src={data.image} 
                            alt={data.title} 
                            className="gadziak__img"
                        />
                    </div>

                    {/* Prawa kolumna - Treść */}
                    <div className='gadziak__content'>
                        <h3 className='gadziak__title'>{data.title}</h3>
                        
                        {data.subtitle && (
                            <h4 className="gadziak__subtitle">{data.subtitle}</h4>
                        )}

                        <div className="gadziak__text-body">
                            {data.paragraphs && data.paragraphs.map((paragraph, index) => (
                                <p key={index} className="gadziak__paragraph">
                                    {paragraph}
                                </p>
                            ))}
                        </div>
                    </div>
                    
                </div>
            </section>
        </div>
    );
}

export default Gadziak;